import React from 'react';

const videoId = process.env.REACT_APP_RUMBLE_VIDEO_ID;
const publisherId = process.env.REACT_APP_RUMBLE_PUBLISHER_ID;
const embedUrlOverride = process.env.REACT_APP_RUMBLE_EMBED_URL;
const monetizedUrl = process.env.REACT_APP_RUMBLE_MONETIZED_URL;
const directUrl = process.env.REACT_APP_RUMBLE_DIRECT_URL || monetizedUrl;
const programmingSheet = process.env.REACT_APP_RUMBLE_PROGRAMMING_SHEET;

const defaultEmbedUrl =
  videoId && publisherId ? `https://rumble.com/embed/${videoId}/?pub=${publisherId}` : null;

const embedUrl = embedUrlOverride || defaultEmbedUrl;

const RumblePlayer = () => {
  if (!embedUrl) {
    return (
      <div className="rumble-page rumble-page--empty">
        <div className="card rumble-meta-card">
          <h1 style={{ fontSize: '2rem' }}>Rumble embed not configured</h1>
          <p>
            Set `REACT_APP_RUMBLE_PUBLISHER_ID` plus `REACT_APP_RUMBLE_VIDEO_ID` (or
            `REACT_APP_RUMBLE_EMBED_URL`) inside `.env` and rebuild the frontend.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="rumble-page">
      <header className="rumble-hero">
        <p className="text-muted">Heaven&apos;s Power Transformation Network</p>
        <h1>Rumble Live Channel</h1>
        <p>Stream the broadcast directly from our official Rumble channel.</p>
      </header>

      <main className="rumble-content">
        <section className="card rumble-player-card">
          <div className="rumble-video">
            <iframe
              src={embedUrl}
              title="Rumble live stream"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture"
            />
          </div>

          <div className="rumble-actions">
            {monetizedUrl && (
              <a
                href={monetizedUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                Watch on Rumble
              </a>
            )}

            {directUrl && directUrl !== monetizedUrl && (
              <a
                href={directUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-muted"
              >
                Direct link
              </a>
            )}
          </div>
        </section>

        <section className="rumble-meta-grid">
          <div className="card rumble-meta-card">
            <h3>Need a direct link?</h3>
            <p className="text-muted">
              Share the monetized Rumble URL whenever you post on socials or newsletters so the
              channel receives credit for every view.
            </p>
            {monetizedUrl && (
              <code className="rumble-link">{monetizedUrl}</code>
            )}
          </div>

          <div className="card rumble-meta-card">
            <h3>Programming rundown</h3>
            <p className="text-muted">
              Producers can review the latest rundown, OBS notes, and contact list inside the shared
              sheet.
            </p>
            {programmingSheet && (
              <a
                className="btn btn-muted"
                href={programmingSheet}
                target="_blank"
                rel="noreferrer"
              >
                Open rundown
              </a>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default RumblePlayer;
